import React from "react";
import { CSSProperties } from "react";
import { Platform, View, ViewStyle } from "react-native";
import { styles } from "./Grid.styles";

interface GridProps {
  children?: React.ReactNode;
}

interface GridCellProps {
  children?: React.ReactNode;
  gridArea: string;
  style?: CSSProperties;
  nativeStyle?: ViewStyle;
}

export const Grid = ({ children }: GridProps): React.ReactElement => {
  if (Platform.OS !== "web") {
    return <View>{children}</View>;
  }

  return <div css={styles.grid}>{children}</div>;
};

const GridCell = ({
  children,
  gridArea,
  style,
  nativeStyle,
}: GridCellProps): React.ReactElement => {
  if (Platform.OS !== "web") {
    return <View style={nativeStyle}>{children}</View>;
  }

  return (
    <div
      css={{
        ...style,
        gridArea,
      }}
    >
      {children}
    </div>
  );
};

Grid.GridCell = GridCell;
